import React from 'react';
import { Card, CardContent, Stack, Typography } from '@mui/material';

import typography from '@/theme/typography';

interface OnboardingFeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const OnboardingFeatureCard = ({ icon, title, description }: OnboardingFeatureCardProps) => (
  <Card
    sx={{
      flex: 1,
      bgcolor: 'grey.100',
      borderRadius: 1,
      boxShadow: 'none'
    }}
  >
    <CardContent sx={{ p: 3 }}>
      <Stack gap={2} alignItems="flex-start">
        {icon}
        <Typography variant="h3" fontWeight={typography.fontWeightMedium} color="text.primary">
          {title}
        </Typography>
        <Typography variant="body2" color="text.primary">
          {description}
        </Typography>
      </Stack>
    </CardContent>
  </Card>
);

export default OnboardingFeatureCard;
